import { render, staticRenderFns } from "./CommunicationDispatched.vue?vue&type=template&id=0bd69b43"
import script from "./CommunicationDispatched.vue?vue&type=script&lang=ts"
export * from "./CommunicationDispatched.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports